import React from 'react';
import Gif from '../assets/nice.gif';

const Footer = () => {
  return (
    <footer className="w-full bg-[#F5F3EF] text-[#4B4033] pt-10">
      {/* FAQ Section */}
      <div className="max-w-screen-lg ml-4 mr-auto px-2 sm:px-6 md:px-40 lg:pl-40">
        <div className="flex items-center gap-4 mb-6">
          <img src={Gif} alt="Animated Icon" className="h-10 w-10 object-contain" />
          <h3 className="text-2xl font-semibold text-[#7A6651]">FAQ</h3>
        </div>

        <div className="flex flex-col gap-6 text-left text-sm">
          <div>
            <h4 className="font-semibold text-[#5D5044] mb-1">
              What services do you offer?
            </h4>
            <p className="text-[#A18C7A]">
              Web development is my core strength, and I’m continuously growing my skills in mobile apps, UI/UX, and QA to expand my capabilities.
            </p>
          </div>
          <div>
            <h4 className="font-semibold text-[#5D5044] mb-1">
              Can I collaborate with you?
            </h4>
            <p className="text-[#A18C7A]">
              Yes! I'm open to freelance projects, internships, and team collaboration.
            </p>
          </div>
          <div>
            <h4 className="font-semibold text-[#5D5044] mb-1">
              What tech stacks do you use?
            </h4>
            <p className="text-[#A18C7A]">
              I work with React.js, Next.js, Node.js, Express, Laravel and various other modern tools.
            </p>
          </div>
          <div>
            <h4 className="font-semibold text-[#5D5044] mb-1">
              How can I contact you?
            </h4>
            <p className="text-[#A18C7A]">
              You can reach me through the contact form or social media linked in my portfolio.
            </p>
          </div>
          <div>
            <h4 className="font-semibold text-[#5D5044] mb-1">
              Are your projects open source?
            </h4>
            <p className="text-[#A18C7A]">
              Some of them are! Check the GitHub links provided in each project section.
            </p>
          </div>
        </div>
      </div>

      {/* Divider */}
      <div className="my-8 border-t border-[#D9CFC2] max-w-screen-lg mx-auto px-4 sm:px-6 md:px-10 lg:px-20"></div>

      {/* Copyright */}
      <div className="py-4 text-center text-sm text-[#8C6D5A]">
        <p>
          © {new Date().getFullYear()} Portfolio by Hugo<br />All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
